import { CurrencyId } from "@/services/currencies/currenciesTypes";
import { createNumericPrice } from "@/services/prices/priceHelpers";
import { z } from "zod";

export enum PaymentMethodUid {
  OnlinePayment = "onlinePayment",
  Card = "card",
}

export const PaymentMethodUid_Schema = z.enum(PaymentMethodUid);

export const PaymentMethodId_Schema = z.number().int().positive();

export const PaymentMethod_Schema = z
  .object({
    id: PaymentMethodId_Schema,
    name: z.string(),
    description: z.string(),
    uid: PaymentMethodUid_Schema,
  })
  .transform(({ ...rest }) => ({
    ...rest,
    price: createNumericPrice(0, CurrencyId.Czk), // @todo Price is not received from API for now - it is always for free
  }));
